import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    metrika_id: 92509164,
    metrikaActions: {},
    sendurl: 'https://rosbankinsurance.ru/api/change-of-insurance-new/send-excel-file',
    DaDataToken: 'd19d3963dafe68db009a421b3baaf979385ab67b',
    DaDataUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    dadatasteps_prefix: {
      3: 'client',
      7: 'policyholder'
    },
    formEl: undefined,
    countryList: [],
    step: 0,
    captchaPassed: false,
    cobs: new Set(),
    copy: false,
    errorMessage: false,
    immortalError: false,
    immortalSuccess: false,
    loading: false,
    successMessage: false,
    basetitles: [
      'Общие сведения',
      'Заявление',
      'Личность Страхователя',
      'Общие сведения',
      'Паспортные данные',
      'Занятость',
      'Условия выплаты',
      'Проверка данных',
      'Паспортные данные',
      'Занятость',
      'Дополнительные вопросы',
      'Состояние здоровья',
      'Данные о болезнях',
      'Дополнительные файлы'
    ],
    stepsdata: [],
    successPopup:{
      type: '',
      title: '',
      text: ''
    },
    errorPopup: {
      type: '',
      title: '',
      text: '',
      btn: ''
    }
  },
  mutations: {
    updateField,
    setFormEl(state, el){
      state.formEl = el
    },
    setCountryList(state, list){
      state.countryList = list
    },
    setCaptcha(state,val){
      state.captchaPassed = val
    },
    addSlidesData(state,count){
      while (count-- > 0)
        state.stepsdata.splice(state.stepsdata.length - 1, 0, {})
    },
    removeSlidesData(state, count){
      while (count-- > 0)
        state.stepsdata.splice(state.stepsdata.length - 2, 1)
    },
    addCob(state, idx){
      state.cobs = new Set([...state.cobs, idx]) 
    },
    removeCob(state,idx){
      let upd = new Set(state.cobs)
      upd.remove(idx)
      state.cobs = upd
    },
    setStepsData(state, payload){
      state.stepsdata = payload
    },
    setCopy(state, payload){
      state.copy = payload
    },
    setSuccessPopup(state, popup) {
      state.successPopup = {...popup}
    },
    setErrorPopup(state, popup) {
      state.errorPopup = {...popup}
    },
    setStep(state,value) {
      state.step = value
    },
    prevStep(state) {
      state.step--
    },
    nextStep(state) {
      state.step++
    },
    setError(state,value) {
      if (state.immortalError)
        state.errorMessage = true
      else
        state.errorMessage = value
    },
    setImmortalError(state,value){
      state.immortalError = value
    },
    setImmortalSuccess(state,value){
      state.immortalSuccess = value
    },
    setLoading(state,value) {
      state.loading = value
    },
    setSuccess(state,value) {
      if (state.immortalSuccess)
        state.successMessage = true
      else
        state.successMessage = value
    },

  },
  actions: {
    initMetrika({state}){
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      window.ym(state.metrika_id, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true,
            webvisor:true
      });
    },
    metrikaAction({state}, action) {
      if (!state.metrikaActions[action]) {
        window.ym(state.metrika_id,'reachGoal',action)
        state.metrikaActions[action] = true
      }
    },
    async loadAll({ commit, dispatch }) {
      let { data, cobscount } = JSON.parse(localStorage.getItem('data'))
      if (!data || cobscount === undefined) return
      await dispatch('setCobsCount', cobscount)
      commit('setStepsData', data)
      console.log('Загружено', data, cobscount)
    },
    saveAll ({state, getters}){
      let data = JSON.parse(JSON.stringify(state.stepsdata))
      let cobscount = getters.cobscount
      
      //Удаляем файлы перед сохранением
      state.stepsdata.forEach((step,i)=>{
        for (let key in step) {
          if (Array.isArray(step[key]) && step[key].length && step[key][0] instanceof File)  {
            data[i][key] = undefined
          }
        }
      })
      
      let save = { data, cobscount }
      localStorage.setItem('data', JSON.stringify(save))
      console.log('Сохранено', JSON.parse(JSON.stringify(save)))
    },
    async setCobsCount({state, getters}, count){
      let val = getters.cobscount < count? 'Да' : 'Нет'
      while(getters.cobscount != count) {
        let limit = Math.abs(getters.cobscount - count), changes = 0
        let arr = ([...state.cobs]).sort((a,b)=>b-a)
        for (let i of arr) {
          for (let key in state.stepsdata[i]) 
            if (key.match('debtcoborrowerquestion')) {
              Vue.set(state.stepsdata,i, { [key]: val })
              changes++
            }
          if (changes >= limit) break
        }
        await Vue.nextTick()
        await Vue.nextTick()
      }
    },
    throwDefaultError(ctx, type){
      this.commit('setErrorPopup', {
        type: type,
        title: 'Упс! <br>Что-то пошло не так...',
        text: 'Приносим свои извинения! На сервере ведутся технические работы. попробуйте подтвердить заявку еще раз',
        btn: 'Повторить'
      })
      this.commit('setError', true)
    },
    throwError(ctx, popup){
      this.commit('setErrorPopup', popup)
      this.commit('setError', true)
    },
    throwSuccess(ctx, popup){
      this.commit('setSuccessPopup', popup)
      this.commit('setSuccess', true)
    },
    async sendForm({state, dispatch}){
      dispatch('metrikaAction', 'daleeFinal')
      if(this.state.immortalError || this.state.immortalSuccess) return false
      if (!state.formEl) return dispatch('throwDefaultError')

      this.commit('setError', false)
      this.commit('setSuccess', false)
      this.commit('setLoading', true)
      
      let formData = new FormData(state.formEl)
      for (let i in state.dadatasteps_prefix) {
        let prefix = state.dadatasteps_prefix[i]
        let source = state.stepsdata[i].dadatainfo
        for (let key in source) 
          formData.append(prefix + key, source[key])
      }
      let v1, v2
      if ((v1 = formData.get('maxarterialpressure')) && (v2 = formData.get('minarterialpressure'))) {
        formData.set('arterialpressure', v1 + '/' + v2)
        formData.delete('maxarterialpressure')
        formData.delete('minarterialpressure')
      }
      state.formEl.querySelectorAll('input[type=checkbox]').forEach(el=>{
        const name = el.getAttribute('name')
        if (el.checked && !formData.get(name)) 
          formData.set(name, 'true')
      })
      let ok = true
      await fetch(this.state.sendurl, {
        method: 'POST',
        body: formData,
        mode: "no-cors",
      }).then(res=>{
          ok = res.ok
          return res.json()
        })
        .then(res=>{
          if (res.error) { throw res[0] }
          if (!ok) { throw 'default' }
          this.commit('setLoading', false)  
          this.commit('setSuccessPopup', {
            type: 'finish',
            title: 'Спасибо за обращение! ',
            text: '<br><span class="popup__smtext">Ответ будет предоставлен в течение двух рабочих дней</span>'
          })
          this.commit('setImmortalSuccess', true)
          this.commit('setSuccess', true)
        })
        .catch((err)=>{ 
          this.commit('setLoading', false) 
          if ((typeof(err) === 'string') && (err != 'default'))
            this.dispatch('throwError', {
              title: 'Ошибка',
              text: err,
              btn: 'Oк'
            })
          else
            this.dispatch('throwDefaultError', 'repeat') 
        })
    }
  },
  getters: {
    getField,
    stepcount: (state, getters) => {
      return getters.steptitles.length
    },
    cobscount: state => {
      let sum = 0
      for (let idx of [...state.cobs].sort()) { 
        try {
          if (Object.values(state.stepsdata[idx])[0] == 'Да') {
            sum++
          }
          else break;
        } catch { console; }
      }
      return sum
    },
    steptitles: (state, getters) => {
      let a = 'Добавить созаемщика', b = ['Личность Созаемщика','Общие сведения','Паспортные данные', 'Занятость', 'Дополнительные вопросы','Состояние здоровья созаемщика', 'Данные о болезнях созаемщика']      
      let cobscount = getters.cobscount
      if (!cobscount)
        return [...state.basetitles, a, 'Завершение']
      if (cobscount == 1)
        return [...state.basetitles, a, ...b, a,'Завершение']
      if (cobscount == 2)
        return [...state.basetitles, a, ...b, a, ...b, a, 'Завершение']
      return [...state.basetitles, a, ...b, a, ...b, a, ...b, 'Завершение']
    }
  }
})
